













































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { parseVisualization } from 'frontend/views/dailyproblems/utils/dcVisualization';
import { SolutionBrief } from 'frontend/types/daily-challenges';

@Component({})
export default class DailyChallengeSolutions extends Vue {
  @Prop(Array) private solutions!: SolutionBrief[];

  private processedHtml(solution: string) {
    return parseVisualization(solution);
  }
}
